export default __webpack_public_path__ + "static/media/starBlank_small.eb66167c.svg";